<template>
  <div>
    <v-row>
      <v-col cols="12" sm="12" md="2"></v-col>

      <v-col cols="12" sm="12" md="8">
        <v-card class="mx-auto my-5 mb-16" max-width="1000">
          <v-app-bar flat>
            <span class="headline">{{ formCompData.title }}</span>
          </v-app-bar>

          <v-card-text>
            <v-container>
              <formComponent
                ref="formComponent"
                :form="formComp"
                v-model="formComp.eventForm"
              />
            </v-container>
          </v-card-text>

          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="grey" outlined @click="back()">
              {{ $t("general.cancel") }}
            </v-btn>
            <v-btn
              :loading="saving"
              :disabled="saving"
              color="primary"
              @click="saveForm"
              data-cy="saveIncidentReportQrQuick"
            >
              {{ $t("general.save") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" sm="12" md="2"></v-col>
    </v-row>
  </div>
</template>

<script>
import formComponent from "../../components/_utils/formComponent/formComponent.vue";
import { getUniqueId } from "../../components/api/api";
import i18n from "../../i18n";

function getDefaultData() {
  return {
    name: "",
    date: new Date(),
    employeeName: "",
    description: "",
    incidentReportType: "quick",
  };
}

export default {
  name: "incidentReportQrCodeFormQuick",
  components: { formComponent },
  data() {
    return {
      saving: false,
      formCompData: {
        title: "incidentReports.createIncidentReports",
        item: null,
      },
      formComp: {
        eventForm: getDefaultData(),
        form: [
          [
            {
              cols: 12,
              sm: 8,
              md: 8,
              class: "pb-0 pt-0",
              id: getUniqueId(),
              componentName: "vTextField",
              config: {
                vModel: "name",
                label: i18n.t("incidentReports.fields.title"),
                dataCy: "name",
                rules: [(v) => !!v || this.$t("general.fieldNeedsToBeFilled")],
              },
            },
            {
              cols: 12,
              sm: 4,
              md: 4,
              class: "pb-0 pt-0",
              id: getUniqueId(),
              componentName: "incidentReportDate",
              config: {},
            },
          ],
          [
            {
              cols: 12,
              sm: 12,
              md: 12,
              class: "pb-0 pt-3",
              id: getUniqueId(),
              componentName: "vTextField",
              config: {
                vModel: "employeeName",
                label: i18n.t("incidentReports.fields.employeeName"),
                dataCy: "employeeName",
                rules: [(v) => !!v || this.$t("general.fieldNeedsToBeFilled")],
              },
            },
          ],
          [
            {
              cols: 12,
              sm: 12,
              md: 12,
              class: "pb-0",
              id: getUniqueId(),
              componentName: "vTextarea",
              config: {
                vModel: "description",
                label: i18n.t("incidentReports.fields.incidentCourse"),
                dataCy: "description",
                rules: [(v) => !!v || this.$t("general.fieldNeedsToBeFilled")],
              },
            },
          ],
        ],
      },
    };
  },
  mounted() {
    this.formCompData.title = this.$t("incidentReports.nearMiss");
  },
  methods: {
    async saveForm() {
      if (!this.$refs.formComponent.validateAllFields()) return;

      const qrCodeKey = this.$route.query.key;
      if (!qrCodeKey) {
        console.log("Missing query param: key");
        this.$emit("saveFailure");
        return;
      }

      this.saving = true;
      try {
        const response = await this.$store.dispatch(
          "createIncidentReportByQrCode",
          {
            qrCodeKey,
            incidentReport: this.formComp.eventForm,
          }
        );

        console.log("Speichern erfolgreich", response);
        this.$emit("saveSuccess");
        this.resetData();
      } catch (err) {
        console.log("Fehler beim Speichern", err);
        this.$emit("saveFailure");
      } finally {
        this.saving = false;
      }
    },
    resetData() {
      this.formComp.eventForm = getDefaultData();
      this.$refs.formComponent.resetForm();
    },
    back() {
      window.location.href = `${window.location.origin}/newIncidentReport?key=${this.$route.query.key}`;
      return;
    },
  },
};
</script>
